'use client';

import { useAnalyticsPageView } from '@repo/segment/Analytics/AnalyticsPageView';
import { useAnonymousId } from '@repo/segment/components/AnonymousIdProvider';
import { useEffect, useState } from 'react';

import { PromotionalBannerLink } from './PromotionalBannerLink';

type PromotionalBannerLinkContainerProps = {
  variant: 'rate-monitor' | 'account-monitor';
  serverHref: string;
};

export function PromotionalBannerLinkContainer({
  variant,
  serverHref,
}: PromotionalBannerLinkContainerProps) {
  const anonymousUserId = useAnonymousId();
  const { pageViewId } = useAnalyticsPageView();
  const [href, setHref] = useState(serverHref);

  // serverHref already carries every server param (with the two client-only params empty).
  // After hydration, fill those two in on the stable href string. Depending on the string
  // plus the two primitive values keeps the dependency array free of any object.
  useEffect(() => {
    const url = new URL(serverHref);
    url.searchParams.set('anonymousUserId', anonymousUserId ?? '');
    url.searchParams.set('driverPageViewId', pageViewId);
    setHref(url.toString());
  }, [serverHref, anonymousUserId, pageViewId]);

  return <PromotionalBannerLink variant={variant} href={href} />;
}
